export * from './entry/mainAny.js';


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/index.js
// module id = 2001
// module chunks = 2